import { get } from '@bigyouth/base'
import emitter from '../emitter'
import { connectCurrentRefinements } from 'instantsearch.js/es/connectors'

let widgetUi = null

const createDataAttributes = (refinement) =>
  Object.keys(refinement)
    .map((key) => `data-${key}="${refinement[key]}"`)
    .join(' ')

const daysCountLabels = {
  1: "Jusqu'à 1 jour",
  2: 'Entre 1 et 2 jours',
  '2+': '+ de 2 jours',
}

const renderListItem = (item) => {
  if (item.attribute === 'themes.name') {
    widgetUi.currentTheme.forEach((instance) => {
      instance.innerHTML = item.refinements[0].label
    })

    emitter.trigger('updateCurrentTheme', { currentTheme: item.refinements[0].label })
  }

  if (item.attribute === 'themes.subTheme.name') {
    widgetUi.currentSubtheme.innerHTML = item.refinements[0].label
    widgetUi.currentSubthemeCount.innerHTML = item.refinements[0].count
  }

  return `
    ${item.attribute !== 'courses.startDate' && item.attribute !== 'timestampStartDate' && item.attribute !== 'timestampPublishDate'
    ? `${item.refinements.map((refinement) =>
        `<li class="ais-Menu-item">
          <button class="thematic thematic--big thematic--delete ${item.attribute !== 'themes.name' && item.attribute !== 'thematics.name' && item.attribute !== 'themes.subTheme.name' ? 'thematic--dark-blue' : ''}" ${createDataAttributes(refinement)}>
            ${item.attribute === 'daysCount' ? daysCountLabels[refinement.label] : item.attribute === 'type' ? config.trads[`search.type.${refinement.label}.plural`] : refinement.label}
            <svg width="24" height="24">
              <use href="#icon-close" xlink:href="#icon-close"></use>
            </svg>
          </button>
        </li>`).join('')}`
    : `<li class="ais-Menu-item">
        <button class="thematic thematic--delete thematic--big thematic--dark-blue" ${createDataAttributes(item.refinements[0])}>
          ${item.refinements.length === 2
          ? `<span ${createDataAttributes(item.refinements[1])} class="hidden"></span> 
            Du ${new Date(item.refinements[0].value * 1000).toLocaleDateString('fr')} au ${new Date(item.refinements[1].value * 1000).toLocaleDateString('fr')}`
          : `A partir du ${new Date(item.refinements[0].value * 1000).toLocaleDateString('fr')}`}
          <svg width="24" height="24">
            <use href="#icon-close" xlink:href="#icon-close"></use>
          </svg>
        </button>
      </li>`}
  `
}

const renderCurrentRefinements = (renderOptions, isFirstRender) => {
  const { items, refine, widgetParams } = renderOptions

  emitter.trigger('updateCurrentTheme', { currentTheme: null })
  widgetUi = widgetParams

  widgetParams.container.innerHTML = `
    <ul class="flex flex-wrap">
      ${items.map(renderListItem).join('')}
    </ul>
  `

  if (items.length > 0) {
    if (widgetParams.suggestionsWrap) {
      widgetParams.suggestionsWrap.classList.add('hidden')
    }
    widgetParams.actives.classList.remove('hidden')
  } else {
    if (widgetParams.suggestionsWrap) {
      widgetParams.suggestionsWrap.classList.remove('hidden')
    }
    widgetParams.actives.classList.add('hidden')
  }

  const manageItem = (target) => {
    const item = Object.keys(target.dataset).reduce(
      (acc, key) => ({
        ...acc,
        [key]: target.dataset[key],
      }),
      {},
    )

    refine(item)

    if (item.attribute === 'courses.startDate' || item.attribute === 'timestampStartDate' || item.attribute === 'timestampPublishDate') {
      emitter.trigger('clearCalendar')
    }

    // case two dates for date selection
    const innerSpan = target.querySelector('span')

    if (innerSpan) {
      const item2 = Object.keys(innerSpan.dataset).reduce(
        (acc, key) => ({
          ...acc,
          [key]: innerSpan.dataset[key],
        }),
        {},
      )

      refine(item2)
    }
  }

  widgetParams.container.querySelectorAll('button').forEach((element) => {
    element.addEventListener('click', (event) => {
      manageItem(event.currentTarget)

      if (event.currentTarget.dataset.attribute === 'themes.name') {
        get('[js-training-list-panel][data-panel="subthemes"]').classList.remove('is-visible')
        get('[js-training-list-panel][data-panel="trainings"]').classList.remove('is-visible')

        const subtheme = get('.thematic--delete[data-attribute="themes.subTheme.name"]')

        if (subtheme) {
          subtheme.click()
        }
      }

      if (event.currentTarget.dataset.attribute === 'themes.subTheme.name') {
        get('[js-training-list-panel][data-panel="trainings"]').classList.remove('is-visible')
      }
    })
  })

  emitter.on('clearDateFilter', () => {
    manageItem(widgetParams.container.querySelector('.thematic[data-attribute="courses.startDate"]'))
  })
}

const customCurrentRefinements = connectCurrentRefinements(renderCurrentRefinements)

export default customCurrentRefinements
